export default "__VITE_ASSET__CnarXiK2__"